<template>
  <div id="orderinfo" class="full_layout" v-loading.fullscreen="loading">
    <div class="flex">
      <div class=" btn-left">
        <router-link class="address-link" :to="{path:'/activityRules'}"></router-link>
        <div class="btn left" @click="handleLeft"></div>
      </div>
      <div class=" btn-right">
        <div class="btn right" @click="handleRight"></div>
      </div>
    </div>
  </div>
</template>
<script>
import { getInfo } from "@/api/public";
export default {
  name: 'orderinfo',
  data() {
    return {
      loading: false,
      userInfo: getInfo()
    }
  },
  filters: {
  },
  mounted() {
  },
  created() { },
  methods: {
    handleLeft() {
      this.$router.push({ path: '/user/exchange', query: { type: 1 } })
    },
    handleRight() {
      this.$router.push({ path: '/user/exchange' })
    }
  }
}

</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.full_layout {
  width: 1000px;
  margin: 90px auto 0;
}

.flex {
  display: flex;
  gap: 30px;
}

.flex>div {
  flex: 1;
  min-width: 0;
  position: relative;
  aspect-ratio: 1 / 1.2;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  position: relative;
}

.address-link {
  position: absolute;
  width: 130px;
  height: 20px;
  right: 9%;
  top: 46%;
}

.btn-left {
  background-image: url('../../../static/images/shizhounian/left.png');
}

.btn-right {
  background-image: url('../../../static/images/shizhounian/right.png');
}
.btn{
  cursor: pointer;
  position: absolute;
  left: 50%;
  bottom: 0%;
  transform: translate(-50%, -50%);
  width: 56%;
  height: 70px;
  background-size: contain;
  background-repeat: no-repeat;
}
.left{
  background-image: url('../../../static/images/shizhounian/leftBtn1.png');
}
.left:hover{
  background-image: url('../../../static/images/shizhounian/leftBtn2.png');
}
.right{
  background-image: url('../../../static/images/shizhounian/rightBtn1.png');
}
.right:hover{
  background-image: url('../../../static/images/shizhounian/rightBtn2.png');
}
</style>



// WEBPACK FOOTER //
// src/pages/user/exchangeinfo.vue